// 修改当前域名
export const transferHost = (isTaiWan) => {
  const link = window.location.href
  if (isTaiWan && link.includes('xiaoman.cn') ) {
    // eslint-disable-next-line no-console
    console.log('link', 'isTaiWan', isTaiWan, link.includes('xiaoman.cn'), isTaiWan && link.includes('xiaoman.cn'))
    window.location.href = link.replace('xiaoman.cn', 'okki.com')
  } else if (!isTaiWan && link.includes('okki.com')) {
    // eslint-disable-next-line no-console
    console.log('link', 'isTaiWan', isTaiWan, link.includes('okki.com'), !isTaiWan && link.includes('okki.com'))
    window.location.href = link.replace('okki.com', 'xiaoman.cn')
  }
}
